const urlMatchRegExp =
	/(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
type ConvertUrlsIntoLinksOptions = {
	encodeSourceText?: boolean;

	//kendo grid forces link to be show as block, by setting the flag the embedded link will have display:inline set
	forceInline?: boolean;

	removeNewLines?: boolean;
};

export function convertUrlsIntoLinks(text: string, options: ConvertUrlsIntoLinksOptions = {}) {
	if (!text) return text;

	if (options.encodeSourceText) {
		text = htmlEncode(text);
	}

	if (options.removeNewLines) {
		text = text.replaceAll('<br>', ' ');
	}

	return text.replaceAll(urlMatchRegExp, (match) => {
		let url = match;

		if (!url.startsWith('http')) {
			url = 'http://' + url;
		}

		//kendo grids have display: block set for links for some reason
		return `<a ${options.forceInline ? 'style="display: inline"' : ''}href='${url}' target='_blank'>${match}</a>`;
	});
}

export function htmlEncode(text: string) {
	const textArea = document.createElement('div');
	textArea.innerText = text;
	return textArea.innerHTML;
}
